import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  allowedMobileOnly: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
